import { alpha, Theme } from '@mui/material'
import { Components } from '@mui/material/styles/components'
import { spacing } from 'c1ui/theme/C1Spacing'
import { palette } from 'c1ui/theme/palette'

export const tooltipColor = alpha(palette.grey[800], 0.95)

export const C1TooltipTheme: Components<Theme>['MuiTooltip'] = {
    defaultProps: {
        arrow: true,
        enterDelay: 100,
        enterNextDelay: 25,
        leaveDelay: 100,
        slotProps: {
            transition: {
                timeout: 50,
            },
            popper: {
                modifiers: [
                    {
                        name: 'preventOverflow',
                        options: {
                            padding: 12,
                            altAxis: true,
                        },
                    },
                ],
            },
        },
    },
    styleOverrides: {
        tooltip: ({ theme }) => ({
            padding: `${spacing.xs} ${spacing.s}`,
            fontSize: 14,
            backgroundColor: alpha(theme.palette.grey[800], 0.95),
            backdropFilter: 'blur(2px)',
        }),

        arrow: ({ theme }) => ({
            color: alpha(theme.palette.grey[800], 0.95),
        }),
    },
}
